import { useCallback, useRef, useState } from 'react'
import SupportListWrapper from 'core/page/SupportListWrapper'
import { getTelesalesURL, listShops } from '../../shops/state/actions'
import { TooltipButton } from '@cbgms/components/form/TooltipButton'
import { ICompany, IGETTakeoverUrlResponse, IPaginatedRequest, ISupportShop, ShopStatus } from '@cbgms/api'
import { useDispatch } from 'react-redux'
import { ListRow } from 'core/types/ListRow'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/styles'

interface ShopListRow {
  Shop: ISupportShop
  Company: ICompany
}

export const TelesalesShopsList = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [frameURL, setFrameURL] = useState('')
  const frameRef = useRef<HTMLIFrameElement>(null)
  const theme = useTheme()

  const openShop = async (shopID: string, frame: boolean) => {
    const { Data: URL } = await dispatch(getTelesalesURL(shopID) as any as IGETTakeoverUrlResponse)
    if (frame) {
      setFrameURL(URL)
      frameRef.current?.scrollIntoView({
        behavior: 'smooth'
      })
    } else {
      window.open(URL, '_blank')
    }
  }

  const loadShopsAction = useCallback((params: IPaginatedRequest) => {
    return listShops({
      ...params,
      search: `Shop.Status|!=|${ShopStatus.Archive}${params.search ? `,${params.search}` : ''}`
    })
  }, [])

  const actionButtons = (row: ListRow<ShopListRow>) => {
    return (
      <>
        <TooltipButton onClick={() => openShop(row.data.Shop.ID, true)} icon='window maximize outline' title={t('telesales.open-frame')} />
        <TooltipButton onClick={() => openShop(row.data.Shop.ID, false)} icon='external' title={t('telesales.open-tab')} />
      </>
    )
  }

  return (
    <>
      <SupportListWrapper
        scope='shops'
        type='list-telesales'
        loadAction={loadShopsAction}
        translationKey='shops'
        actions={actionButtons}
        hideExport
      />
      <iframe
        ref={frameRef}
        src={frameURL}
        style={{
          height: frameURL ? '100vh' : '0',
          width: `calc(100% + ${theme.spacing(2)})`,
          margin: `0 0 -${theme.spacing(1)} -${theme.spacing(1)}`,
          display: 'block'
        }}
        frameBorder='0'
      />
    </>
  )
}

export default TelesalesShopsList
